<template>
  <div class="studentStatus">
    <div class="container">
      <div class="studentStatus-header">
        <swiper></swiper>
      </div>
      <div class="studentStatus-contens">
        <div class="item-studentStatus-contens">
          <div class="studentStatus-title"><i></i>学员动态<i></i></div>
          <div class="studentStatus-content">
            <div class="item-contens-box" v-for="item in studentStatus" :key="item.id">
              <div class="content-img">
                <img :src="item.simg" />
              </div>
              <div class="content-cons">
                <div class="cons-title">{{item.title}}</div>
                <div class="cons-content">{{item.content}}</div>
                <div class="cons-more" @click="tolink(item.link)">了解更多</div>
              </div>
            </div>
          </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Swiper from '../components/swiper.vue'
export default {
  name: 'studentStatus',
  components: {
    Swiper
  },
  data () {
    return {
      studentStatus: [
        {
          id: 1,
          simg: require('../assets/student/one.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU1NzE2MzI1Ng==&mid=2247484164&idx=1&sn=c58750ff8f8cda588eb940df179e9e04&chksm=fc38b493cb4f3d85a62f9777652964809dbd8328ad3ac33f09ac8e8982d9d092181b40b45961&scene=0&xtrack=1&key=b17219827522b0143d1c7b9bc38bbb4d4ff07a918a2c97aa47be46bf88d63e20a919634ee991485c81e1d0cce64b0310535151d3b9b09b5eef7a6362b31e18f5131250d84524ca95ced980539c5b9f79&ascene=1&uin=NzE4MDY3Njcz&devicetype=Windows+10+x64&version=62090529&lang=zh_CN&exportkey=AUhZISKQ%2BMdELOfynvc1h4Y%3D&pass_ticket=HXo1DbonEpij%2BahAjjvZlkrKJwiQFhbjSxfib4vxOwfCiFVQTom%2BbYrlzYV3%2BlAR',
          title: '大象老师一周岁生日倾情献礼！感谢关注弈小象的每一个你！',
          content: '今天是一个非常特别而又快乐的日子，我的一周岁生日到啦！没想到我过生日的消息这么快就被大家知道啦，小朋友们也纷纷 送来了祝福！小朋友们的生日祝福真的太让我感动了~家长朋友们也告诉我，许多正在弈小象学习象棋的小朋友都曾经看过我的 视频，听过我讲课（自豪的小表情）！虽然弈小象的老师们都很优秀，但我也是功不可没呢！'
        },
        {
          id: 2,
          simg: require('../assets/student/ll.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU1NzE2MzI1Ng==&mid=2247483938&idx=1&sn=1e380450f6ef419a74d8e53fb39d2103&chksm=fc38b5b5cb4f3ca3b3a0262cf7c960f733aca296bb173370aa49fdcc7cbd81ea7b9f1a6316d9&scene=0&xtrack=1&key=d88973753fa10558dfb4d62abdb877c5664d13b8ee24fdf942d1fca4e0e67a69e129475aeb2247e3a21a5380dd8a93fe09625eea24ab7fd01b8f04b9f302831aa76d388f7fe1c01cb4100a648b54bc61&ascene=1&uin=NzE4MDY3Njcz&devicetype=Windows+10+x64&version=62090529&lang=zh_CN&exportkey=Af0Epi1q7AFoE5NTLzxfmxk%3D&pass_ticket=HXo1DbonEpij%2BahAjjvZlkrKJwiQFhbjSxfib4vxOwfCiFVQTom%2BbYrlzYV3%2BlAR',
          title: '从全国冠军到海归创业——走进弈小象创始人兰宇',
          content: '在采访期间，兰宇并没有大谈行业趋势、公司战略这些“高配”话题，或许下棋出身的人，不仅深谋远虑，也是低调务实的吧。 最后再次谈到创业的初心，兰宇说到：教育是一项伟大的事业，象棋是一座通达的桥梁，它们带给孩子智慧和快乐，拉进了心 灵之间的距离；象棋是我们的国粹，孩子是我们未来的希望，文化自信不能只停留在我们这一代，我们更要把好的东西传承下 去。 “让更多的孩子喜欢象棋、学会下棋、因象棋而受益”，这就是弈小象成立的初心。'
        },
        {
          id: 3,
          simg: require('../assets/student/ss.png'),
          link: 'https://mp.weixin.qq.com/s?__biz=MzU1NzE2MzI1Ng==&mid=2247483898&idx=1&sn=6de0309f640f015b19cedf8d63a6c9c1&chksm=fc38b66dcb4f3f7bd01e4b8ac6f8332dab8b52fbe3c78b6db3a7d0b17bb854029c1ba6c615f1&scene=0&xtrack=1&key=b17219827522b0144fa798b64f1eff7a6e2c54057ec5ba26ad9e46f235e34dfa4fbd545e61845e2c188c249ac6d884fab9dc3fbde3e76709b62fe974cb057f48bed071f337b64ab110fbeaa02820506d&ascene=1&uin=NzE4MDY3Njcz&devicetype=Windows+10+x64&version=62090529&lang=zh_CN&exportkey=AeVglE%2B1DlrW6ZAY5UTx304%3D&pass_ticket=HXo1DbonEpij%2BahAjjvZlkrKJwiQFhbjSxfib4vxOwfCiFVQTom%2BbYrlzYV3%2BlAR',
          title: '走近弈小象名师——宋洁',
          content: '宋洁对笔者说，经过几年商业圈的历练，发现经营企业和下棋也有相通之处。不论成败得失，企业本身要有一定责任感，让更多 的人受益。其实下棋也一样，自己棋艺精进固然是好，如果让更多的人因为下棋受益，享受下棋的乐趣，通过下棋指导生活、感 悟人生，这是一件更有意义的事情。于是，宋洁又开始了新的挑战——加入弈小象团队，培养象棋新生力量，让更多的小朋友 爱上棋、下好棋。'
        },
        {
          id: 4,
          simg: require('../assets/student/children.png'),
          link: 'https://mp.weixin.qq.com/s/D20zgJaV-EnSCz1SIKoHCQ',
          title: '最走心的成长报告：因为有了可爱的你们，弈小象才能变得更好！',
          content: '在这里，孩子们收获的不仅仅是知识，更是一份无比宝贵的人生经历。线上互动这样有趣的课程模式，让你们感受到了亲自动 手操作的乐趣。不同于在学校的大班，每个小朋友举手发言的机会都多了起来，大家在课堂上也屡屡获得了小奖杯，收获了肯 定与鼓励。 三周学习中的点点滴滴汇集起来，形成了一幅多彩的画卷。每个孩子都用自己手中的画笔，画下了精彩独特的一笔。'
        },
        {
          id: 5,
          simg: require('../assets/student/report.png'),
          link: 'https://mp.weixin.qq.com/s/Ql3icKC2AeF1i_laSxw4CQ',
          title: '领跑少儿象棋教育，弈小象轻课上线仅3个月，全网订阅量突破3万+！',
          content: '为了让更多孩子接受象棋教育，从而培养象棋思维，弈小象的象棋冠军与教育专家借鉴了全球最新教育理论，将象棋与国学、AI 相结合，打造了《儿童的第一堂象棋思维启蒙课》。这堂动画课以象棋为工具，带领孩子穿越古今，纵横中外，让孩子在掌握 象棋基础知识的同时，学习趣味历史。'
        }
      ]
    }
  },
  created () {
  },
  methods: {
    tolink (link) {
      console.log(link)
      window.location.href = link
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .studentStatus{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .container{
      width: 100%;
      .studentStatus-header{
        width: 100%;
        height: 450px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .studentStatus-contens {
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 40px;
        .item-studentStatus-contens {
          width: 100%;
          margin-bottom: 45px;
          .studentStatus-title {
            color: $colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(230px, 40px, '../assets/imgs/xian.png');
            i{
              display: inline-block;
              width: 23px;
              height: 23px;
              margin-right: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_left.png');
            }
            i:last-of-type{
              margin-left: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_right.png');
            }
          }
          .studentStatus-content {
            width: 1180px;
            margin: auto;
            margin-top: 35px;
            margin-bottom: 60px;
            .item-contens-box{
              width: 100%;
              border-bottom: 1px solid #eeeeee;
              margin-bottom: 30px;
              @include flexed();
              .content-img {
                width: 372px;
                height: 372px;
                margin-right: 33px;
                margin-bottom: 30px;
                img{
                  width: 100%;
                  height: 100%;
                }
              }
              .content-cons {
                width: 775px;
                height: 372px;
                position: relative;
                /*background-color: #4B5692;*/
                .cons-title{
                  font-size:24px;
                  font-family:Microsoft YaHei;
                  font-weight:bold;
                  color:rgba(51,51,51,1);
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(0,-50%);
                }
                .cons-content {
                  font-size:14px;
                  font-family:Microsoft YaHei;
                  font-weight:400;
                  color:rgba(101,101,101,1);
                  position: absolute;
                  top: 66%;
                  left: 0;
                  transform: translate(0,-50%);
                  text-align: left;
                }
                .cons-more {
                  width: 172px;
                  height: 49px;
                  border-radius: 10px;
                  border: 1px solid #cecece;
                  text-align: center;
                  line-height: 49px;
                  font-size: 14px;
                  color: #333333;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  &:hover{
                    border: 1px solid #4DAAEC;
                    background-color: #4DAAEC;
                    color: #ffffff;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/studentStatus.vue